export default __webpack_public_path__ + "static/media/cn.ede831f0.svg";